import React, { useState } from "react";
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

export const TextActiveEditComponent = ({
    text,
    setText,
    label,
}: {
    text: string;
    setText: (text: string) => void;
    label?: string;
}) => {
    const [isEditingText, setIsEditingText] = useState(false);
    return <Spacing size={'sm'} direction={'horizontal'} className={'items-center'}>
    {isEditingText ? (
      <SimpleInput
        label={label ?? ''}
        value={text}
        onChange={setText}
      />
    ) : (
      <S2Typography
        variant="headline-4"
        translatedContent={text}
      />
    )}

    {isEditingText ? (
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            setIsEditingText(false);
          },
        }}
        variant={'outline'}
        size={'small'}
      >
        <S2Typography
          variant={'headline-7'}
          translatedContent={'Save'}
        />
      </Button>
    ) : (
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => {
            setIsEditingText(true);
          },
        }}
        variant={'outline'}
        size={'small'}
      >
        <S2Typography
          variant={'headline-7'}
          translatedContent={'Edit'}
        />
      </Button>
    )}
  </Spacing>
}
